<template>
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-12">
        <h1>
          <span>Områden</span>
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <ul class="button-list">
          <li class="button-list-item" v-on:click="showArea()">
            <span class="button-list-item-caption">Alla</span>
            <span class="button-list-item-icon">
              <i class="fa fa-chevron-right"></i>
            </span>
          </li>
          <li class="button-list-item" v-for="area in orderedAreas" :key="area.id" v-on:click="showArea(area)">
            <span class="button-list-item-caption">{{ area.title }}</span>
            <span class="button-list-item-icon">
              <i class="fa fa-chevron-right"></i>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <loader v-if="loading"></loader>
  </div>
</template>

<script>
import { settings } from '@/resources';
import router from '@/router';
import { communicationUtil } from '@/utilities';

import { Loader } from '@/components';

export default {
  name: 'AreaList',
  mixins: [communicationUtil],
  data: function() {
    return {
      areas: [],
      loading: false
    };
  },
  mounted: function() {
    this.loadAreas();
  },
  components: {
    loader: Loader
  },
  computed: {
    orderedAreas: function() {
      return this.areas.sort((a, b) => {
        return a.sort_id - b.sort_id;
      });
    }
  },
  methods: {
    handleException: function(exception) {
      console.log('Exception', exception);
    },
    loadAreas: function() {
      this.loading = true;
      this.get(`${settings.backend}/areas/list`).then(response => {
        this.areas = response.data;
        this.loading = false;
      });
    },
    showArea: function(area) {
      this.$store.commit('area', area ? area.id : -1);
      this.$store.commit('areaType', area && area.virtual ? 'virtual' : 'regular');
      router.push('/area');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/AreaList.vue